// extracted by mini-css-extract-plugin
module.exports = {"container":"counter-module--container--2o3La","counterPicture":"counter-module--counterPicture--37__7","ledPicture":"counter-module--ledPicture--2gRcP"};